import { html } from 'lit';
import type { SvgIcon } from '../entities';

export const analyticsAndInsights: SvgIcon = {
  key: 'd466d58a-ebc3-4bb7-9843-fa2233e76251',
  icon: html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--stroke, var(--uui-color-default))"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="12" x2="12" y1="20" y2="10" />
    <line x1="18" x2="18" y1="20" y2="4" />
    <line x1="6" x2="6" y1="20" y2="16" />
  </svg>`,
};
